import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getSettings, getIsLoading, getGalleries } from '../../selectors/studio/gallerySettings';
import { loadSettings, saveSettings, resetState } from '../../actions/studio/gallerySettings';
import { Props } from './GalleryDisplaySettingsModal';

export type StateProps = Pick<Props, 'settings' | 'isLoading' | 'galleries'>;
export type DispatchProps = Pick<Props, 'onLoadSettings' | 'onSaveSettings' | 'onResetState'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  settings: getSettings(state),
  isLoading: getIsLoading(state),
  galleries: getGalleries(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onLoadSettings: loadSettings,
  onSaveSettings: saveSettings,
  onResetState: resetState,
};

export default connect(mapStateToProps, mapDispatchToProps);
